import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button, buttonBaseClasses, Card, CardHeader, styled, Divider } from '@mui/material';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';

export const CardStyled = styled(Card)(({ theme }) => ({
  width: '100%',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardHeaderStyled = styled(CardHeader)(({ theme }) => ({
  display: 'flex',
  justifyItems: 'center',
  alignItems: 'center',
  borderBottom: `2px solid ${theme.palette.secondary.dark}`,
  backgroundColor: theme.palette.primary.main,
}));

export const Content = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
}));

export const UpdateMessageStyle = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '2rem',
  color: theme.palette.secondary.light,
}));

export const PersonalContent = styled(Box)(() => ({
  display: 'flex',
  gap: '1rem',
  justifyContent: 'space-between',
}));

export const EditIconStyled = styled(EditOutlinedIcon)(() => ({
  cursor: 'pointer',
}));

export const BodySmallRegularStyled = styled(BodySmallRegular)(({ theme }) => ({
  color: theme.palette.secondary.dark,
}));

export const EditButtonStyled = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: '0.2rem',
  cursor: 'pointer',
  gap: '0.5rem',
  color: theme.palette.common.white,
  textTransform: 'none',

  [`&.${buttonBaseClasses.disabled}`]: {
    color: theme.palette.common.white,
    opacity: 0.2,
  },
}));

export const BoxStyled = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
}));

export const BoxGroupStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '1rem',
  gap: '1.5rem',
  alignSelf: 'center',
}));

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  padding: 0,
}));

export const AlignButton = styled('div')(() => ({
  paddingTop: '1rem',
  width: '100%',
  maxWidth: '18.5rem',
}));

export const AlignText = styled(Box)(() => ({
  display: 'flex',
  textAlign: 'center',
}));

export const CustomBodySmallRegular = styled(BodySmallRegular)(({ theme }) => ({
  overflowWrap: 'break-word',
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  margin: '0.75rem 0',
  borderStyle: 'dashed',
  borderWidth: '0.063rem',
  borderColor: theme.palette.secondary.light,
  opacity: '0.5',
  borderImage: `repeating-linear-gradient(to right, ${theme.palette.secondary.light} 0, ${theme.palette.secondary.light} 0.5rem, transparent 0.5rem, transparent 1rem) 100% 1`,
}));

export const ColumnStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
}));

export const TextDivider = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const TextSeparate = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  textAlign: 'right',
}));

export const TextRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
}));

export const TextOpacity = styled(Box)(() => ({
  opacity: '0.5',
}));
